import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';
import { ROUTES } from '@/routes/paths';
import { LeaveSettings } from '../components/LeaveSettings';

/**
 * Leave Master Data page — standalone route for managing leave policy
 * configuration (leave types and holiday calendar). Reachable via the Master
 * Data hub for any admin/superadmin, and (since 2026-08-23) via a "Manage
 * Leave Types" button on LeavesPage itself for HR admins/superadmins — the
 * button this page's own header used to imply already existed but didn't.
 */
export function LeaveMasterDataPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col">
      {/* Page header with back navigation */}
      <div className="flex items-center gap-3 border-b border-outline px-6 py-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(ROUTES.leaves)}
          aria-label="Back to Leave Management"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Leaves
        </Button>
      </div>

      {/* Main content — renders the Leave Types + Holiday Calendar tabs */}
      <div className="flex-1 overflow-y-auto">
        <LeaveSettings />
      </div>
    </div>
  );
}
